export default __webpack_public_path__ + "2f6635858b00b8371d393d5b12f4f453.svg";